import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { Breadcrumbs } from '../../AbstractElements'
import { Card, Container, Row, Table } from 'reactstrap'
import { Col, FormLabel } from 'react-bootstrap'
import { useLoader } from '../../_helper/LoaderContext'
import { getInvoiceDetail, getTransactionDetail } from './service/ledger-service'
import Payment from './Payment'
import { useLab } from '../../_helper/PharmacyProvider'
import { formatDoctorDisplayDate } from '../../utils/dateTime/dateFormat'
import { useCurrency } from '../../_helper/currencyContext'
import MyPagination from '../pagination'
import { useTranslation } from 'react-i18next'

export default function ViewDetailLedger() {
    const { t } = useTranslation();
    const { id } = useParams()
    const { setLoading } = useLoader();
    const { currentLab } = useLab();
    const [showRecipt, setShowRecipt] = useState(false);
    const [paymentData, setPaymentData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const { getCurrencySymbol, convertCurrency, currency } = useCurrency();
    const [trData, setTrData] = useState({})

    const [data, setData] = useState([]);

    useEffect(() => {
        getDetail()
    }, [id, currentPage, entriesPerPage,])

    const getDetail = async () => {
        setLoading(true)
        try {
            const res = await getTransactionDetail(id);
            if (res.data.success == true) {
                setPaymentData(res.data.data.totals);
                setData(res.data.data.payments);
                setTotalEntries(res.data.data.totalPages || 0);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    }

    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    const openMode = async (data) => {
        setLoading(true)
        try {
            const res = await getInvoiceDetail(data.salesId);
            if (res.data.success == true) {
                setShowRecipt(true);
                setTrData(res.data.data)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const handlePageSizeChange = (e) => {
        const newSize = Number(e.target.value);
        setEntriesPerPage(newSize);  // Use the correct setter
        setCurrentPage(1);           // Reset to page 1
    }

    const getStartingSerialNumber = () => {
        return (currentPage - 1) * entriesPerPage + 1;
    };

    return (
        <>
            <Breadcrumbs mainTitle={t("Transactions Detail")} parent={t("Home")} subParent={t("Ledger List")} title={t("Transactions Detail")} />
            <Container fluid={true}>
                <Row>
                    <Col>
                        {/* <div className="tw-flex tw-flex-wrap tw-gap-4">
                            <div className="tw-flex-1 tw-min-w-[160px] text-center">
                                <div className="bg-primary tw-text-white tw-rounded-lg tw-p-4 tw-shadow">
                                    <p className="tw-text-2xl tw-font-bold mb-1 tw-mt-1">{getCurrencySymbol("INR")}{paymentData.totalNet?.toFixed(2)}</p>
                                    <p className="tw-text-sm tw-opacity-90 mb-1">Net Total</p>
                                </div>
                            </div>
                            <div className="tw-flex-1 tw-min-w-[160px] text-center">
                                <div className="bg-success tw-text-white tw-rounded-lg tw-p-4 tw-shadow">
                                    <p className="tw-text-2xl tw-font-bold mb-1 tw-mt-1">{getCurrencySymbol("INR")}{paymentData.totalPaid?.toFixed(2)}</p>
                                    <p className="tw-text-sm tw-opacity-90 mb-1">Total Paid</p>
                                </div>
                            </div>
                            <div className="tw-flex-1 tw-min-w-[160px] text-center">
                                <div className="tw-bg-red-600 tw-text-white tw-rounded-lg tw-p-4 tw-shadow">
                                    <p className="tw-text-2xl tw-font-bold mb-1 tw-mt-1">{getCurrencySymbol("INR")}{paymentData.totalDue?.toFixed(2)}</p>
                                    <p className="tw-text-sm tw-opacity-90 mb-1">Total Due</p>
                                </div>
                            </div>
                            <div className="tw-flex-1 tw-min-w-[160px] text-center">
                                <div className="tw-bg-cyan-500 tw-text-white tw-rounded-lg tw-p-4 tw-shadow">
                                    <p className="tw-text-2xl tw-font-bold mb-1 tw-mt-1">{paymentData.totalTransactions}</p>
                                    <p className="tw-text-sm tw-opacity-90 mb-1">Total Transactions</p>
                                </div>
                            </div>
                            <div className="tw-flex-1 tw-min-w-[160px] text-center">
                                <div className="tw-bg-amber-500 tw-text-white tw-rounded-lg tw-p-4 tw-shadow">
                                    <p className="tw-text-2xl tw-font-bold mb-1 tw-mt-1">{getCurrencySymbol("INR")}{paymentData.totalRefund?.toFixed(2)}</p>
                                    <p className="tw-text-sm tw-opacity-90 mb-1">Total Refund</p>
                                </div>
                            </div>
                        </div> */}
                        <Card >
                            {/* Transaction History Table */}
                            <div className="tw-px-3 tw-py-3">
                                {/* <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
                                    <h2 className="tw-text-xl tw-font-semibold tw-text-gray-800">Transaction History</h2>
                                    <div className="tw-text-sm tw-text-gray-600">
                                        Customer Name: <span className="tw-font-medium tw-text-gray-900"></span>
                                    </div>
                                </div> */}

                                <div
                                    className="recent-table table-responsive currency-table tw-rounded-lg tw-border tw-border-black custom-slim-scrollbar"
                                    style={{ overflowX: "auto" }}
                                >
                                    <Table className="mb-0 table-center table-bordered table-hover doctor-table" style={{ tableLayout: "fixed", minWidth: "965px", overflowX: "auto" }}>
                                        <thead>
                                            <tr>
                                                <th className="text-center bg-primary tw-text-center" style={{ width: "50px", whiteSpace: "nowrap" }}>
                                                    <b>#</b>
                                                </th>
                                                <th className="bg-primary text-white text-left" style={{ width: "130px", whiteSpace: "nowrap" }}><b>{t("Transaction Type")}</b></th>
                                                <th className="bg-primary text-white text-left" style={{ width: "120px", whiteSpace: "nowrap" }}><b>{t("Date")}</b></th>
                                                <th className="bg-primary text-white" style={{ width: "95px", whiteSpace: "nowrap" }}><b>{t("Net Total")}</b></th>
                                                <th className="bg-primary text-white" style={{ width: "90px", whiteSpace: "nowrap" }}><b>{t("Credit (+)")}</b></th>
                                                <th className="bg-primary text-white" style={{ width: "90px", whiteSpace: "nowrap" }}><b>{t("Debit (-)")}</b></th>
                                                <th className="bg-primary text-white" style={{ width: "150px", whiteSpace: "nowrap" }}><b>{t("Outstanding Balance")}</b></th>
                                                <th className="bg-primary text-white" style={{ width: "85px", whiteSpace: "nowrap" }}><b>{t("Method")}</b></th>
                                                {/* <th className="bg-primary text-white" style={{ width: "85px" }}><b>Currency</b></th> */}
                                                <th className="bg-primary text-white" style={{ width: "85px", whiteSpace: "nowrap" }}><b>{t("Status")}</b></th>
                                                <th className="bg-primary text-white text-center" style={{ width: "70px", whiteSpace: "nowrap" }}><b>{t("Action")}</b></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.length > 0 ? (
                                                data.map((item, index) => {
                                                    const serialNumber = getStartingSerialNumber() + index;
                                                    return (
                                                        <tr
                                                            key={item.id}
                                                            className={`tw-border-b tw-border-gray-200 hover:tw-bg-gray-50 ${index % 2 === 0 ? '' : ''}`}
                                                        >
                                                            <td className="text-center font-weight-bold">
                                                                {serialNumber}
                                                            </td>
                                                            {/* # */}
                                                            {/* <td className="tw-px-4 tw-py-4 tw-font-medium tw-text-gray-900">
                                                            {index + 1}
                                                        </td> */}

                                                            {/* Transaction Type */}
                                                            <td>
                                                                <span className="tw-inline-flex tw-items-center tw-px-2.5 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-bold text-capitalize bg-primary">
                                                                    {item.salesType}
                                                                </span>
                                                            </td>

                                                            {/* Date */}
                                                            <td className="tw-text-gray-700" style={{ whiteSpace: "nowrap" }}>
                                                                <div>{formatDoctorDisplayDate(item.createdAt, currentLab) || "-"}</div>
                                                            </td>

                                                            {/* Net Total */}
                                                            <td className="tw-font-bold tw-text-gray-900" style={{ whiteSpace: "nowrap" }}>
                                                                {item.netTotal > 0 ? (
                                                                    <>
                                                                        {getCurrencySymbol(item.currency)}{item.netTotal?.toFixed(2)}
                                                                    </>
                                                                ) : (
                                                                    <>-</>
                                                                )}
                                                            </td>

                                                            {/* Credit (+) */}
                                                            <td className="text-success fw-bold" style={{ whiteSpace: "nowrap" }}>
                                                                {getCurrencySymbol(item.currency)}{item.amount?.toFixed(2)}
                                                            </td>

                                                            {/* Debit (-) */}
                                                            <td className="tw-font-bold text-danger" style={{ whiteSpace: "nowrap" }}>
                                                                {item.credit?.toFixed(2) || "-"}
                                                            </td>

                                                            {/* Outstanding Balance */}
                                                            <td className="tw-font-bold tw-text-gray-900" style={{ whiteSpace: "nowrap" }}>
                                                                {item.currency &&
                                                                    item.balances &&
                                                                    Object.keys(item.balances).length > 0 &&
                                                                    item.balances[item.currency] !== undefined
                                                                    ? `${getCurrencySymbol(item.currency)}${Number(item.balances[item.currency]).toFixed(2)}`
                                                                    : "0"
                                                                }
                                                            </td>

                                                            {/* Method */}
                                                            <td className="tw-capitalize">
                                                                {item.paymentType !== "refund" ? (
                                                                    <span className="tw-bg-gray-200 tw-border tw-border-gray-700 px-2 py-0.5 tw-rounded text-black" style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                                                                        {item.paymentType}
                                                                    </span>
                                                                ) : (
                                                                    <span className="tw-bg-gray-200 tw-border tw-border-gray-700 px-2 py-0.5 tw-rounded text-black" style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                                                                        {t("Cash")}
                                                                    </span>
                                                                )}
                                                                {/* {item.method} */}
                                                            </td>

                                                            {/* Currency */}
                                                            {/* <td className="tw-px-4 tw-py-4 tw-text-gray-700">
                                                                {item.currency}
                                                            </td> */}

                                                            {/* Status */}
                                                            <td>
                                                                {item.isSettled ? (
                                                                    <span className="badge bg-success">{t("Settled")}</span>
                                                                ) : (
                                                                    <>
                                                                        {item.isPaid && (
                                                                            <span className="badge bg-primary">{t("Paid")}</span>
                                                                        )}
                                                                        {item.isPartialPaid && (
                                                                            <span className="badge bg-warning text-dark">{t("Partial Paid")}</span>
                                                                        )}
                                                                        {item.salesType === 'payment' &&
                                                                            !item.isPaid &&
                                                                            !item.isSettled &&
                                                                            !item.isPartialPaid && (
                                                                                <span className="badge bg-primary">{t("Payment")}</span>
                                                                            )}
                                                                        {item.salesType === 'refund' &&
                                                                            !item.isPaid &&
                                                                            !item.isSettled &&
                                                                            !item.isPartialPaid && (
                                                                                <span className="badge bg-danger">{t("Refund")}</span>
                                                                            )}
                                                                    </>
                                                                )}
                                                            </td>

                                                            {/* Action - Eye Icon with Tooltip */}
                                                            <td className="text-center">
                                                                <div className="d-inline-flex align-items-center justify-content-center">
                                                                    {item.rePayment !== true && item.isSettled == false ? (
                                                                        <button className='success-action-button' onClick={() => openMode(item)}>
                                                                            <i className="fa fa-eye" style={{ fontSize: "18px" }}></i>
                                                                        </button>
                                                                    ) : (
                                                                        <div>-</div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={10} className="text-center py-4 text-muted">
                                                        {t("No data available")}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                                <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-sm-between gap-2 mt-2 pt-1">
                                    <div className="show-entries d-inline-flex align-items-center">
                                        <FormLabel className="mb-0 text-muted" style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                                            {t("Show")}&nbsp;
                                        </FormLabel>
                                        <select
                                            style={{
                                                display: "inline-block",
                                                width: "auto",
                                                height: "28px",
                                                padding: "0.15rem 1.6rem 0.15rem 0.5rem",
                                                fontSize: "12px",
                                                lineHeight: 1.2,
                                                margin: "0 4px"
                                            }}
                                            value={entriesPerPage}
                                            onChange={handlePageSizeChange}
                                            className="form-control form-control-sm"
                                        >
                                            <option value={5}>5</option>
                                            <option value={10}>10</option>
                                            <option value={20}>20</option>
                                            <option value={30}>30</option>
                                            <option value={50}>50</option>
                                        </select>
                                        <FormLabel className="mb-0 text-muted" style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                                            {t("entries")}
                                        </FormLabel>
                                    </div>
                                    <div className="d-flex justify-content-center justify-content-sm-end overflow-auto" style={{ maxWidth: "100%" }}>
                                        <MyPagination totalPages={totalPages} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
                                    </div>
                                </div>
                                {/* <div className="mt-3">
                                    <MyPagination totalPages={totalPages}
                                        currentPage={currentPage}
                                        onPageChange={(page) => setCurrentPage(page)}></MyPagination>
                                </div> */}
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container >
            <Payment show={showRecipt} trData={trData}
                onHide={() => setShowRecipt(false)} />
        </>
    )
}
